'use strict';

angular.module('shiftTraderApp')
  .factory('AvailabilityChangeRequests', function (ServerUrls, Session, $http, $injector, $q) {
    var STATE_MAPPING = {
      PENDING: 0,
      IN_REVIEW: 1,
      APPROVED: 2,
      DISAPPROVED: 3
    };

    var endpointName = 'availability_change_requests/';

    var AvailabilityChangeRequest = function(values) {
      var A = {};


      A.$initialize = function(initData) {
        angular.extend(A, initData);
        A.effective_date = moment.utc(initData.effective_date).tz(Session.getTimezone());
        A.expires_at = moment.utc(initData.expires_at).tz(Session.getTimezone());
        A.created_at = moment.utc(initData.created_at).tz(Session.getTimezone());

        if (initData.user_availability_change_requests) {
          var UserAvailabilityChangeRequests = $injector.get('UserAvailabilityChangeRequests');
          A.user_availability_change_requests = _.map(A.user_availability_change_requests, UserAvailabilityChangeRequests.initWithData);
        }
      };

      A.$initialize(values);

      A.$calcStats = function() {
        A._stats = {
          numApproved: _.where(A.user_availability_change_requests, function(uacr) {
            return _.any(uacr.availability_sets, function(availSet) {
              return availSet.$isApproved() && availSet.active;
            })
          }).length,
          numWorkingOnIt: _.where(A.user_availability_change_requests, function(uacr) {
            return _.any(uacr.availability_sets, function(availSet) {
                return availSet.$isPending() && availSet.active;
              })
          }).length,
          numNotSubmitted: _.where(A.user_availability_change_requests, function(uacr) {
            return uacr.availability_sets.length === 0 || _.all(uacr.availability_sets, function(availSet) {
              return availSet.$isPending() && availSet.active;
            })
          }).length,
          numInReview: _.where(A.user_availability_change_requests, function(uacr) {
            return _.any(uacr.availability_sets, function(availSet) {
                return availSet.$isInReview() && availSet.active;
              })
          }).length
        };
      };

      A.$isPending = function() {
        return A.state === STATE_MAPPING.PENDING;
      };

      A.$isInReview = function() {
        return A.state === STATE_MAPPING.IN_REVIEW;
      };

      A.$isApproved = function() {
        return A.state === STATE_MAPPING.APPROVED;
      };

      A.$isDisapproved = function() {
        return A.state === STATE_MAPPING.DISAPPROVED;
      };

      A.$isExpired = function() {
        return moment.utc().isAfter(A.expires_at);
      };



      A.$makeInactive = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          active: false
        })
          .then(function(response) {
            that.active = false;
            return response.data;
          }, function(response) {
            console.log('Error in AvailabilityChangeRequest.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$approve = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          action: 'approve'
        })
          .then(function (response) {
            that.approved_by = response.data.approved_by;
            that.approved_by_user = response.data.approved_by_user;
            that.messages = response.data.messages;
            that.active = response.data.active;
            return response.data;
          }, function (response) {
            console.log('Error in AvailabilityChangeRequest.$makeInactive');
            return $q.reject(response);
          });
      };

      A.$disapprove = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          action: 'disapprove'
        })
          .then(function(response) {
            that.approved_by = response.data.approved_by;
            that.approved_by_user = response.data.approved_by_user;
            that.messages = response.data.messages;
            that.active = response.data.active;
            return response.data;
          }, function(response) {
            return $q.reject(response);
          });
      };

      A.$sendMessage = function(messageText, usr) {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + endpointName + this.id, {
          message: {
            text: messageText,
            user_id: usr.id,
            user_first_name: usr.first_name,
            user_last_name: usr.last_name
          }
        })
            .then(function(response) {
              that.messages = response.data.messages;
              return response.data;
            }, function(response) {
              console.log('Error in AvailabilityChangeRequest.$approve');
              return $q.reject(response);
            });
      };

      return A;
    };

    var AvailabilityChangeRequests = {};

    AvailabilityChangeRequests.create = function (data) {
      return $http.post(ServerUrls.current.railsApi + endpointName, data)
        .then(function (response) {
          return new AvailabilityChangeRequest(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    AvailabilityChangeRequests.getAll = function(params) {
      var config = {
        params: _.extend({}, params)
      };

      return $http.get(ServerUrls.current.railsApi + endpointName, config)
          .then(function(response) {
            return _.map(response.data, function(ar) {
              return new AvailabilityChangeRequest(ar);
            });
          }, function(response) {
            return $q.reject(response);
          });

    };

    AvailabilityChangeRequests.getById = function(theId) {
      return $http.get(ServerUrls.current.railsApi + endpointName + theId)
        .then(function(response) {
          return new AvailabilityChangeRequest(response.data);
        }, function(response) {
          return $q.reject(response);
        });
    };

    AvailabilityChangeRequests.getAllApprovedDaysOff = function(extraParams) {
      var data = {
        //organization: 'primary',
        status: 'approved',
        type: 'daysoff',
        active: true
      };

      if (extraParams) {
        _.extend(data, extraParams);
      }

      return AvailabilityChangeRequests.getAll(data);
    };

    AvailabilityChangeRequests.getAllDaysOffNeedingApproval = function() {
      var data = {
        //organization: 'primary',
        status: 'awaitingapproval',
        type: 'daysoff',
        active: true
      };

      return AvailabilityChangeRequests.getAll(data);
    };

    AvailabilityChangeRequests.getRecentlyUpdatedOrNewDaysOff = function(params) {
      var data = {
        type: 'daysoff',
        mode: 'recent_new_or_updated'
      };

      angular.extend(data, params);

      return AvailabilityChangeRequests.getAll(data);
    };

    AvailabilityChangeRequests.initWithData = function(data) {
      return new AvailabilityChangeRequest(data);
    };

    AvailabilityChangeRequests.stateMapping = STATE_MAPPING;

    return AvailabilityChangeRequests;
  });
